var exports = {
  "Qs": "CustomStatusDisplay.module__content___N3dWV0",
  "pF": "CustomStatusDisplay.module__singleLine___N3dWV0",
  "tD": "CustomStatusDisplay.module__constrained___N3dWV0",
  "IY": "CustomStatusDisplay.module__truncatedText___N3dWV0",
  "j9": "CustomStatusDisplay.module__clamped___N3dWV0",
  "H0": "CustomStatusDisplay.module__statusEmoji___N3dWV0",
  "My": "CustomStatusDisplay.module__statusEmojiWrapper___N3dWV0",
  "hb": "CustomStatusDisplay.module__staticEmoji___N3dWV0",
  "oG": "CustomStatusDisplay.module__animatedEmoji___N3dWV0",
  "kK": "CustomStatusDisplay.module__hiddenVisually___N3dWV0",
  "SA": "CustomStatusDisplay.module__jumbo___N3dWV0",
  "We": "CustomStatusDisplay.module__editableWrapper___N3dWV0",
  "Ke": "CustomStatusDisplay.module__editableTextHover___N3dWV0",
  "BW": "CustomStatusDisplay.module__editPencilIcon___N3dWV0",
  "dX": "CustomStatusDisplay.module__editableEmojiOnly___N3dWV0",
  "qf": "CustomStatusDisplay.module__placeholder___N3dWV0",
  "Dm": "CustomStatusDisplay.module__placeholderIcon___N3dWV0",
  "RC": "CustomStatusDisplay.module__placeholderText___N3dWV0",
  "_C": "CustomStatusDisplay.module__emojiPressable___N3dWV0",
  "on": "CustomStatusDisplay.module__emojiTooltipTrigger___N3dWV0",
};

module.exports = exports;
